import styled from 'styled-components'
import type { CSSProperties } from 'react'
import { Card, Flex, Tabs } from 'antd'

export const NameCell = styled.div`
  font-weight: 500;
`

export const PageBody = styled.div`
  padding: 1.5em;
  background: #fafafa;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
`

export const FullWidthCard = styled(Card)`
  width: 100%;
`

export const FilterActionBar = styled(Flex)`
  padding-left: 1.5em;
  padding-right: 1.5em;
  padding-top: 1em;
  padding-bottom: 1em;
`

export const labelStyle: CSSProperties = { textAlign: 'left', fontSize: 14 }
export const valueStyle: CSSProperties = { textAlign: 'right', fontSize: 14, fontWeight: 500 }

export const fullWidthStyle: CSSProperties = { width: '100%' }
export const fullWidthFlexStyle: CSSProperties = {
  width: '100%',
  display: 'flex',
}
export const fullHeightMinHeightZeroStyle: CSSProperties = { height: '100%', minHeight: 0 }
export const scrollAreaStyle: CSSProperties = { width: '100%', overflow: 'auto', flex: 1, minHeight: 0 }
export const tableRootFlexStyle: CSSProperties = { width: '100%', flex: 1, minHeight: 0 }

export const inputUnitSuffixTextStyle: CSSProperties = {
  fontSize: 'inherit',
  userSelect: 'none',
  whiteSpace: 'nowrap',
}

export const searchMaxWidthStyle: CSSProperties = { maxWidth: '400px' }
export const drawerFilterStackStyle: CSSProperties = { width: '100%' }

export const filterActionBarStyles: CSSProperties = {
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  paddingTop: '1em',
  paddingBottom: '1em',
}

export const summaryLabelStyle: CSSProperties = {
  fontSize: 11,
  lineHeight: '14px',
  color: 'rgba(0, 0, 0, 0.45)',
}

export const summaryValueStyle: CSSProperties = {
  lineHeight: '20px',
}

export const summaryFooterWrapStyle: CSSProperties = {
  width: '100%',
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
  background: '#FFFFFF',
}

export const detailHeaderStyle: CSSProperties = {
  paddingLeft: '1em',
  paddingRight: '1em',
}

export const detailTitleStyle: CSSProperties = {
  fontWeight: 'bold',
  paddingLeft: '1em',
  marginBlock: 0,
}

export const tabContainerStyles: CSSProperties = {
  display: 'flex',
  flex: 1,
}

export const seedInventoryTabsBarStyles: CSSProperties = {
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  backgroundColor: '#FFFFFF',
}

export const seedInventoryTabsStyles: CSSProperties = {
  flexGrow: 1,
  backgroundColor: '#FAFAFA',
  minHeight: 0,
}

export const SeedInventoryDrawerTabs = styled(Tabs)`
  display: flex;
  flex: 1;
  min-height: 0;

  .ant-tabs-content-holder {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .ant-tabs-content {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .ant-tabs-tabpane {
    height: 100%;
    overflow: auto;
  }
`

export const seedInventoryTabRootStyle: CSSProperties = {
  padding: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
}

export const splitterContainerStyle: CSSProperties = { flex: 1, minHeight: 0 }
export const splitterLeftPanelStyle: CSSProperties = { display: 'flex', position: 'relative' }
export const leftPanelFlexStyle: CSSProperties = { height: '100%', minHeight: 0 }
export const leftPanelOverlayStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  background: 'rgba(250, 250, 250, 0.55)',
  pointerEvents: 'none',
  zIndex: 1,
}
export const splitterRightPanelStyle: CSSProperties = {
  background: '#FAFAFA',
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}
export const collapseButtonStyle: CSSProperties = {
  position: 'absolute',
  left: -30,
  top: '1em',
  transform: 'translateX(-50%)',
  zIndex: 2,
  minWidth: 32,
  padding: '4px 8px',
}
export const rightPanelContentStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: '1em',
}
export const rightPanelContentNoScrollStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  padding: 0,
}
export const detailTitleRowStyle: CSSProperties = { paddingBottom: '1em' }

export const drawerRootStyle: CSSProperties = { paddingBottom: '1em' }
export const drawerTopBarStyle: CSSProperties = { marginBottom: 4 }
export const drawerChromeStyle: CSSProperties = {
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  paddingTop: '1em',
  backgroundColor: '#FFFFFF',
}
export const drawerTabsContainerStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
}
export const drawerTabPaneScrollableStyle: CSSProperties = {
  display: 'flex',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: '1em',
  boxSizing: 'border-box',
  backgroundColor: '#FAFAFA',
}
export const drawerLastUpdatedStyle: CSSProperties = {
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.7)',
}
export const drawerSeasonRowStyle: CSSProperties = { position: 'relative', top: 40, zIndex: 1 }
export const drawerSeasonLabelStyle: CSSProperties = {
  ...drawerLastUpdatedStyle,
  fontWeight: 700,
  fontStyle: 'italic',
}
export const drawerLastUpdatedLabelStyle: CSSProperties = { fontWeight: 700, fontStyle: 'italic', marginRight: 10 }
export const drawerRowStyle: CSSProperties = { width: '100%' }
export const drawerSeedInventoryCardStyle: CSSProperties = { flex: '3 1 0%', minWidth: 0 }
export const drawerGrowerDetailsCardStyle = (gapPx: number): CSSProperties => ({
  flex: `0 0 calc((100% - ${gapPx * 2}px) / 3)`,
  minWidth: 0,
})
export const drawerInventoryNotesCardStyle = (gapPx: number): CSSProperties => ({
  flex: `0 0 calc(100% - ${gapPx}px - ((100% - ${gapPx * 2}px) / 3))`,
  minWidth: 0,
})
export const seedInventoryNotesRootStyle: CSSProperties = { width: '100%' }
export const seedInventoryNotesLoadingStyle: CSSProperties = { padding: '16px 0' }
export const seedInventoryNotesEmptyStyle: CSSProperties = { color: '#8C8C8C', fontSize: 13, padding: '8px 0' }
export const seedInventoryNotesTimelineStyle: CSSProperties = { position: 'relative', paddingLeft: 28 }
export const seedInventoryNotesRailStyle: CSSProperties = {
  position: 'absolute',
  left: 9,
  top: 0,
  bottom: 0,
  width: 2,
  backgroundColor: '#D9D9D9',
}
export const seedInventoryNotesItemStyle: CSSProperties = { position: 'relative', paddingRight: 32 }
export const seedInventoryNotesEditActionsStyle: CSSProperties = { marginTop: 8 }
export const seedInventoryNotesMarkerStyle: CSSProperties = {
  position: 'absolute',
  left: -24,
  top: 6,
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: '#52C41A',
  border: '2px solid #FFFFFF',
  boxSizing: 'content-box',
}
export const seedInventoryNotesMoreActionsWrapStyle: CSSProperties = { position: 'absolute', right: 0, top: -4 }
export const seedInventoryNotesTextStyle: CSSProperties = {
  color: '#262626',
  fontSize: 14,
  lineHeight: '22px',
  whiteSpace: 'pre-wrap',
}
export const seedInventoryNotesMetaStyle: CSSProperties = {
  color: '#8C8C8C',
  fontSize: 12,
  lineHeight: '20px',
  marginTop: 4,
}

export const twoValueTableStyle: CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
}
export const tableCellLabelStyle: CSSProperties = { paddingRight: 12, verticalAlign: 'middle' }
export const tableCellValueStyle: CSSProperties = {
  paddingRight: 12,
  paddingLeft: 12,
  verticalAlign: 'middle',
  textAlign: 'right',
}
export const tableCellLineStyle: CSSProperties = {
  width: 1,
  padding: 0,
  verticalAlign: 'middle',
  border: 'none',
}
export const rowLineInnerStyle: CSSProperties = {
  borderLeft: '1px solid rgba(0, 0, 0, 0.15)',
  minHeight: 20,
}

export const seedInventoryEditStackedFieldStyle: CSSProperties = {
  width: '100%',
  marginBottom: 12,
}
export const seedInventoryEditFormStyle: CSSProperties = { width: '100%' }
export const seedInventoryEditTopBarStyle: CSSProperties = { marginBottom: 4 }
export const seedInventoryEditLastUpdatedStyle: CSSProperties = {
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.45)',
}
export const seedInventoryEditCardStyle: CSSProperties = { flex: '3 1 0%', minWidth: 0 }
export const seedInventoryEditReadOnlyRowsStyle: CSSProperties = { marginBottom: 8 }
export const seedInventoryEditFieldStackStyle: CSSProperties = { marginTop: 16 }
export const seedInventoryEditRowStyle: CSSProperties = { width: '100%' }
export const seedInventoryEditSecondRowStyle = (gapPx: number): CSSProperties => ({
  width: '100%',
  marginTop: gapPx,
})
export const seedInventoryEditGrowerDetailsCardStyle = (gapPx: number): CSSProperties => ({
  flex: `0 0 calc((100% - ${gapPx * 2}px) / 3)`,
  minWidth: 0,
})
export const seedInventoryEditInventoryNotesCardStyle = (gapPx: number): CSSProperties => ({
  flex: `0 0 calc(100% - ${gapPx}px - ((100% - ${gapPx * 2}px) / 3))`,
  minWidth: 0,
})
export const labelValueRowStyle: CSSProperties = { width: '100%', height: 38 }
export const labelPedigreeRowStyle: CSSProperties = { width: '100%', height: 72 }
export const labelPedigreeLabelStyle: CSSProperties = { display: 'block' }
export const labelPedigreeRowLabelStyle: CSSProperties = { ...labelStyle, display: 'block' }
export const labelPedigreeValueWrapStyle: CSSProperties = {
  marginTop: 16,
  display: 'flex',
  alignItems: 'center',
}

export const seedInventoryAddFormPagePaddingStyle: CSSProperties = {
  padding: '24px clamp(16px, 3vw, 32px) 32px',
  boxSizing: 'border-box',
}
export const seedInventoryAddSectionBlockStyle: CSSProperties = { marginBottom: 16 }
export const seedInventoryAddSectionTitleStyle: CSSProperties = {
  display: 'block',
  fontSize: 12,
  marginBottom: 8,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
}
export const seedInventoryAddFieldCellStyle: CSSProperties = {
  flex: '1 1 160px',
  minWidth: 160,
  maxWidth: 280,
}
export const seedInventoryAddSeededPedigreePlaceholderStyle: CSSProperties = { lineHeight: '40px' }
export const seedInventoryAddContentStyle: CSSProperties = { backgroundColor: '#fff' }
export const seedInventoryAddWarningAlertStyle: CSSProperties = { marginBottom: 16 }
export const seedInventoryAddFormStyle: CSSProperties = { maxWidth: 1200 }
export const seedInventoryAddSeedingIntentionsTopRowStyle: CSSProperties = { marginBottom: 12 }

// History Tab Styles
export const historyDateStyle: CSSProperties = {
  color: '#8C8C8C',
  fontSize: 12,
  lineHeight: '20px',
  width: 150,
  flexShrink: 0,
}

export const historyMarkerStyle: CSSProperties = {
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: '#52C41A',
  border: '2px solid #FFFFFF',
  boxSizing: 'content-box',
  flexShrink: 0,
  position: 'relative',
  zIndex: 1,
}

export const historyMetaStyle: CSSProperties = {
  color: '#262626',
  fontSize: 14,
  lineHeight: '22px',
  fontWeight: 'bold',
}

export const historyActionStyle: CSSProperties = {
  fontWeight: 'normal',
}

export const historyContentStyle: CSSProperties = {
  flex: 1,
}

export const customTimelineStyle: CSSProperties = {
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}

export const customRailStyle: CSSProperties = {
  position: 'absolute',
  left: 164,
  top: 0,
  bottom: 0,
  width: 2,
  backgroundColor: '#D9D9D9',
  zIndex: 0,
}

export const historyCardStyle: CSSProperties = {
  width: '100%',
}

export const historyEntryRowStyle: CSSProperties = {
  display: 'flex',
  gap: 8,
  alignItems: 'flex-start',
  marginBottom: 24,
  position: 'relative',
}

export const historyDiffContainerStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '300px 1fr',
  gap: '8px 12px',
  fontSize: 13,
  lineHeight: '20px',
}

export const historyDiffRowStyle: CSSProperties = {
  display: 'contents',
}

export const historyDiffFieldStyle: CSSProperties = {
  color: '#8C8C8C',
}

export const historyDiffValueStyle: CSSProperties = {
  color: '#262626',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '4px',
}

export const historyTimelineContainerStyle: CSSProperties = {
  width: '100%',
}

export const historyArrowStyle: CSSProperties = {
  margin: '0 8px',
}

// Styled components for history display
export const PedigreeLabel = styled.div<{ backgroundColor: string }>`
  display: inline-flex;
  height: 22px;
  padding: 0 12px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background: ${(props) => props.backgroundColor};
  color: white;
  font-size: 12px;
  width: fit-content;
`

export const OldValueBubble = styled.span`
  display: inline-flex;
  height: 22px;
  padding: 0 12px;
  align-items: center;
  border-radius: 12px;
  background: #f0f0f0;
  color: black;
  font-size: 12px;
`

export const NewValueBubble = styled.span`
  display: inline-flex;
  padding: 6px 12px;
  align-items: flex-start;
  border-radius: 12px;
  background: #e6f7ff;
  color: black;
  font-size: 12px;
  flex-wrap: wrap;
`

export const DeletedValueBubble = styled.span`
  display: inline-flex;
  padding: 6px 12px;
  align-items: flex-start;
  border-radius: 12px;
  background: #ffebee;
  color: #8c8c8c;
  font-size: 12px;
  text-decoration: line-through;
  flex-wrap: wrap;
`

export const StrikethroughValue = styled.span`
  text-decoration: line-through;
  color: #8c8c8c;
  font-size: 12px;
  word-wrap: break-word;
  display: block;
`
